const ProjectFeaturedImage = ({ url = 'https://picsum.photos/600/400', title = '' }) => {
    return(
        <picture>
            <img src={url} alt=""/>
        </picture>
    )
}

export default ProjectFeaturedImage;